import React, { useContext } from 'react';
import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';

export type InteractionSourceContextType = InteractionSource | '';

export const InteractionSourceContext =
    React.createContext<InteractionSourceContextType>('');

export const useInteractionSourceContext = (): InteractionSourceContextType =>
    useContext(InteractionSourceContext);

export function withInteractionSource<T>(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WrappedComponent: React.FC<T>,
    interactionSource: InteractionSource,
) {
    return class extends React.Component<T> {
        render() {
            return (
                <InteractionSourceContext.Provider value={interactionSource}>
                    <WrappedComponent {...this.props} />
                </InteractionSourceContext.Provider>
            );
        }
    };
}
